import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import './style.scss';

const desktopHeaderSkeleton = () => {
  return (
    <div className={'d-flex px-3 block-info-header-skeleton'}>
      <Skeleton className={'m-2'} variant="rect" width={100} height={45} />
      <Skeleton className={'m-2'} variant="rect" width={100} height={45} />
      <Skeleton className={'m-2'} variant="rect" width={100} height={45} />
    </div>
  );
};
export default desktopHeaderSkeleton;